import { Component, OnInit } from '@angular/core';
import { AlertController, NavController } from 'ionic-angular';
import { MeteorObservable } from 'meteor-rxjs';
import * as _ from 'lodash';
import { ISDEV, APP_TITLE } from "../../services/config";
import { HttpService } from '../../services/httpService';
import { App } from "ionic-angular";
import { Pictures } from 'api/collections';
import { Profile } from 'api/models';
import { Storage } from '@ionic/storage';
import { AuthenticationService } from '../../services/congito';

@Component({
  selector: 'user-profile',
  templateUrl: 'user-profile.html'
})

export class UserProfilePage implements OnInit {
  picture: string;
  profile: Profile;
  email: string;
  phoneMask: Array < string | RegExp > ;

  wbs: boolean = false;
  public isDev = ISDEV;

  constructor(
    private _app: App,
    private alertCtrl: AlertController,
    private navCtrl: NavController,
    private storage: Storage,
    public httpService: HttpService,
    public authenticationService: AuthenticationService
  ) {
    this.phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  }
  ionViewDidEnter() {
    this._app.setTitle(APP_TITLE);
  }

  ngOnInit(): void {
    MeteorObservable.autorun().subscribe(() => {
      // MeteorObservable.subscribe('userProfilePhoto').subscribe();
      this.httpService.MeteorSubscribe('userProfilePhoto');
      const user = this.authenticationService.MeteorUser();
      this.profile = {
        name: '',
        phoneNumber: '',
        pictureId: undefined,
        ...user.profile,
      };
      this.email = _.get(user, 'emails[0].address', '');
      this.picture = Pictures.getPictureUrl(this.profile.pictureId);
    });
    this.storage.get('wbs').then(wbs=>this.wbs=wbs)

  }

     // set a key/value
     // storage.set('wbs', 'false');


      getWbs(val){
        this.storage.set('wbs', val);
      }

  save(): void {
    const updates: { phoneNumber ? : string, name ? : string } = {};
    const user = this.authenticationService.MeteorUser();
    const originalProfile = user.profile || {};
    const newPhoneNumber = (this.profile.phoneNumber || '').replace(/[^\d]/g, '');


    console.log("this.profile.name", this.profile)


    if(newPhoneNumber !== originalProfile.phoneNumber) {
      updates.phoneNumber = newPhoneNumber;
    }

    if(this.profile.name && originalProfile.name !== this.profile.name) {
      updates.name = this.profile.name;
    }

    if(Object.keys(updates).length === 0) {
      return;
    }

    /*
    MeteorObservable.call('updateProfile', updates).subscribe({
      next: () => {},
      error: (err: Error) => {
        this.showError(err);
      }
    });
    */
    this.httpService.MeteorCall('updateProfile', updates)
      .then(() => {})
      .catch((e: Error) => {
        this.showError(e);
      });
  }

  eventHandler(keyCode) {
    if(keyCode == 13) {
      let activeElement = <HTMLElement>document.activeElement;
      activeElement && activeElement.blur && activeElement.blur();
    }
  }

  showError(err: Error): void {
    const alert = this.alertCtrl.create({
      title: 'Oops!',
      message: err.message,
      buttons: ['OK']
    });

    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/user-profile/user-profile.ts